import { useState } from "react";
import { Copy, Check } from "lucide-react";

export const CopyBox = ({ value, testid, multiline = false }) => {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = value;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setDone(true);
    setTimeout(() => setDone(false), 1500);
  };
  return (
    <div className="relative group rounded-md border border-slate-200 bg-slate-950 text-slate-100">
      <pre data-testid={testid} className={`font-mono text-xs p-3 pr-12 overflow-x-auto ${multiline ? "whitespace-pre" : "whitespace-pre-wrap [overflow-wrap:anywhere]"}`}>{value}</pre>
      <button
        type="button"
        onClick={copy}
        data-testid={`${testid}-copy`}
        className="absolute top-2 right-2 p-1.5 rounded bg-slate-800 hover:bg-blue-600 transition-colors duration-150"
        aria-label="Copy"
      >
        {done ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
      </button>
    </div>
  );
};
